import { useState } from 'react'
import { Link as ScrollLink } from 'react-scroll'
import Logo from '../../../assets/images/logo.png'
import { useNavigate } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { Link } from 'react-router-dom'

interface NavbarProps {
  use: string
}

function Navbar({ use }: NavbarProps) {
  const navigate = useNavigate()
  const [showBar, setShowBar] = useState(false)
  return (
    <div className={`navbar flex ${showBar ? 'show' : ''}`}>
      <div className='flex nav-wrapper items-center justify-between '>
        <div className='logo'>
          <img src={Logo} alt='' />
          <Icon
            icon='bx:bx-menu'
            className='menu'
            onClick={() => setShowBar(!showBar)}
          />
        </div>
        <div className='rest flex justify-between items-center'>
          {use === 'home' ? (
            <ul className='flex'>
              {/* @ts-ignore */}
              <ScrollLink to='home' smooth={true} duration={1000}>
                <li>Home</li>
              </ScrollLink>
              {/* @ts-ignore */}
              <ScrollLink to='about-us' smooth={true} duration={1000}>
                <li>About Us</li>
              </ScrollLink>
              {/* @ts-ignore */}
              <ScrollLink to='why-us' smooth={true} duration={1000}>
                <li>Why Us</li>
              </ScrollLink>
              {/* @ts-ignore */}
              <ScrollLink to='reviews' smooth={true} duration={1000}>
                <li>Testimonials </li>
              </ScrollLink>
              {/* @ts-ignore */}
              <ScrollLink to='faqs' smooth={true} duration={1000}>
                <li>FAQs</li>
              </ScrollLink>
            </ul>
          ) : (
            <ul className='flex'>
              {/* @ts-ignore */}
              <Link to='/'>
                <li>Home</li>
              </Link>
            </ul>
          )}
          <div className='buttons'>
            <button onClick={() => navigate('/users/login')}>Login</button>
            <button onClick={() => navigate('/create-account')}>Sign Up</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Navbar
